import React from "react";

import StoreFrontStyles from "components/glamclub/StoreFront.module.scss";
import { Container } from "components/grid/Container";

export class StoreFrontWrap extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      cols: 1
    };

    this.renderProductRows = this.renderProductRows.bind(this);
    this.resize = this.resize.bind(this);
  }

  resize () {
    let cols;

    if (window.innerWidth >= 992) {
      cols = 3;
    } else if (window.innerWidth >= 768) {
      cols = 2;
    } else {
      cols = 1;
    }

    if (cols !== this.state.cols) {
      this.setState({
        cols: cols
      });
    }
  }

  componentDidMount () {
    this.resize();

    window.addEventListener("resize", this.resize);
  }

  componentWillUnmount () {
    window.removeEventListener("resize", this.resize);
  }

  renderProductRows () {
    let { children } = this.props;

    let grouped = [];
    let groupLimit = Math.ceil(children.length / this.state.cols);

    for (let n = 0; n < groupLimit; n++) {
      grouped.push(
        children.slice(n * this.state.cols, (n + 1) * this.state.cols)
      );
    }

    return grouped.map((item, key) => {
      return (
        <div className={StoreFrontStyles["product-row"]} key={key}>
          {item}
        </div>
      );
    });
  }

  render () {
    return (
      <Container fluid>
        {this.renderProductRows()}
      </Container>
    );
  }
}
